export default async function getCoordinates(data) {
  const { api, id, address } = data;
  try {
    const response = await api.geocode(address);
    const data = parseCoordinates(id, response);
    return getResponse(null, data);
  } catch (error) {
    return getResponse(error, data);
  }
}

function getResponse(error, data = null) {
  return {
    isOk: !error,
    data: data,
    error: error,
  };
}

function parseCoordinates(id, response) {
  const object = response.geoObjects.get(0);

  return {
    id,
    coordinates: object ? object.geometry.getCoordinates() : null,
  };
}
